export default __webpack_public_path__ + "static/media/x.e6712f7b.svg";